import React, {useCallback} from 'react';

// Core components
import RadioGroup from '@material-ui/core/RadioGroup';
import Radio from '@material-ui/core/Radio';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import makeStyles from "@material-ui/core/styles/makeStyles";

const StyledRadioGroup = ({ onChange, heading, value, options }) => {
    const styles = useStyles();

    const handleChange = useCallback(event => {
        const newVal = event.target.value;
        onChange(newVal);
    }, [onChange]);

    return(
        <div className={styles.container}>
            <FormControl component={'fieldset'}>
                <FormLabel component={'legend'}>{ heading || '' }</FormLabel>
                <RadioGroup onChange={handleChange} value={value || ''}>
                    {
                        options.map(option => {
                            return (
                                <FormControlLabel
                                    control={<Radio color={"primary"}/> }
                                    label={option.label}
                                    value={option.value}
                                    labelPlacement={'end'}
                                    key={option.value}
                                />
                            );
                        })
                    }
                </RadioGroup>
            </FormControl>
        </div>
    )
};

const useStyles = makeStyles({
    container: {
        paddingLeft: "0.5rem"
    }
})

export default StyledRadioGroup;